export const STATE_DSP_DOCS = 'dsp_docs';
export const ACTION_ON_TOGGLE_CODE_SNIPPET_BACKGROUND_STYLE = '@DspDocs/ON_TOGGLE_CODE_SNIPPET_BACKGROUND_STYLE';

export const DSP_DOCS_CLIENT_BASE_URL = '/documentation/dsp';

export const nativeRequestInformationData = [
    {
        field: '\`context\`',
        value: 'The context in which the ad appears; currently not used and always set to \`1501\` .',
    },
    {
        field: '\`plcmtcnt\`',
        value: 'The placement count (AppLovin requests only one placement per request).',
    },
    {
        field: '\`plcmttype\`',
        value: 'The design/format/layout of the ad unit being offered. \`1\` means in the feed of the content; \`2\` means in the atomic unit of the content.',
    },
    {
        field: '\`ver\`',
        value: 'The version of the Native Ad Specification to which the request complies; set to \`1.2\` .',
    },
]

export const nativeRequestAssetData = [
    {
        id: '\`1\` (required)',
        field: '\`title\`',
        type: 'N/A',
        value: 'Title of the native ad. Maximum length is 50 characters. Always passes \`Bidrequest.imp.native.request.assets.len\` , the maximum length of the text in the title element.',
    },
    {
        id: '\`2\` (required)',
        field: '\`img\`',
        type: '3',
        value: 'Main image of the native creative. Minimum required size is 627×627. Recommended size is 1200×627.',
    },
    {
        id: '\`3\` (optional)',
        field: '\`img\`',
        type: '1',
        value: 'Icon image of the native creative. Minimum required size is 50×50.',
    },
    {
        id: '\`4\` (optional)',
        field: '\`data\`',
        type: '2',
        value: 'Descriptive text associated with the text product or service being advertised. Maximum length is 150 characters. {NEWLINE} {NEWLINE} \`Bidrequest.imp.native.request.assets.data\` contains \`.type\` and \`.len\` objects. The \`type\` contains the Type ID of the element supported by the publisher. The \`len\` is the maximum length of the text in the element’s response.',
    },
    {
        id: '\`5\` (required)',
        field: '\`data\`',
        type: '12',
        value: 'CTA description—descriptive text describing a “call to action” button for the destination URL. Maximum length is 15 characters. {NEWLINE} {NEWLINE} \`Bidrequest.imp.native.request.assets.data\` contains \`.type\` and \`.len\` objects. The \`type\` contains the Type ID of the element supported by the publisher. The \`len\` is the maximum length of the text in the element’s response.',
    },
    {
        id: '\`6\` (optional)',
        field: '\`data\`',
        type: '3',
        value: 'Rating of the product being offered to the user. For example, an app’s rating in an app store on a 0–5 scale.',
    },
    {
        id: '\`8\` (optional)',
        field: '\`data\`',
        type: '1',
        value: '“Sponsored By” message in which the response should contain the brand name of the sponsor. Maximum length is 25 characters.',
    },
]

export const bidRequestObjectData = [
    {
        attribute: '\`app\`',
        value: 'Details via an App object (see {“App/SPACE/Object”}(#app-object) ) about the publisher’s app.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`at\`',
        value: 'Auction type. If \`1\` then first-price auction; if \`2\` then second-price auction (always set to \`1\` for AppLovin).',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`bapp\`',
        value: 'Block list of applications by their platform-specific, exchange-independent application identifiers. On Android, these are bundle or package names (such as “com.foo.mygame”); on iOS, these are numeric IDs. Note that this field is sent on an opt-in basis; reach out to your account manager if you want to be enabled for this field. A maximum of 30 bundles will be passed. Bids containing other bundle IDs blocked by publishers will be invalidated and will not participate in the auction.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`badv\`',
        value: 'Block list of advertisers by their top-level domains (for example, “ford.com”). A maximum of 30 domains will be passed. Bids containing other domains blocked by publishers will be invalidated and will not participate in the auction.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`bcat\`',
        value: 'Blocked IAB categories for this impression. See {“Blocked/SPACE/Categories”}(#blocked-categories)  for a list.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`device\`',
        value: 'Details via a Device object (see {“Device/SPACE/Object”}(#device-object) ) about the user’s device to which the impression is delivered.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`ext\`',
        value: 'Placeholder for exchange-specific extensions to OpenRTB.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`id\`',
        value: 'Unique ID of the bid request',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`imp\`',
        value: 'Array of Imp objects (see {“Impression/SPACE/Object”}(#impression-object) ) representing the impressions offered. Only one impression object will be passed.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`regs\`',
        value: 'A Regs object that specifies any industry, legal, or governmental regulations in force for this request.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`regs.ext.ccpa\`',
        value: 'Flag indicating if this request is subject to the CCPA regulations, where \`0\` = no, \`1\` = yes.',
        alwayspassed: 'yes, if \`regs\` is passed',
    },
    {
        attribute: '\`regs.ext.consent\`',
        value: 'Flag indicating if a user has granted consent, where \`0\` = no, \`1\` = yes.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`regs.ext.gdpr\`',
        value: 'Flag indicating if this request is subject to the GDPR regulations, where \`0\` = no, \`1\` = yes.',
        alwayspassed: 'yes, if \`regs\` is passed',
    },
    {
        attribute: '\`regs.ext.us_privacy\`',
        value: 'See {OpenRTB/SPACE/Extension/SPACE/for/SPACE/US/SPACE/Privacy}(https://github.com/InteractiveAdvertisingBureau/USPrivacy/blob/master/CCPA/OpenRTB%20Extension%20for%20USPrivacy.md#extension-object-us_privacy-attribute).',
        alwayspassed: 'no',
    },
    {
        attribute: '\`source\`',
        value: 'A Source object that provides data about the inventory source and which entity makes the final decision.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`source.ext\`',
        value: 'Placeholder for exchange-specific extensions to OpenRTB. AppLovin passes \`schain\` in the extension with subobject \`ver\`, \`complete\`, and \`nodes\`. Please refer to {IAB’s/SPACE/spec}(https://github.com/InteractiveAdvertisingBureau/openrtb/blob/master/supplychainobject.md#openrtb-object-supplychain) .',
        alwayspassed: 'yes, if \`source\` is passed',
    },
    {
        attribute: '\`tmax\`',
        value: 'Maximum time, in milliseconds, to submit a bid to avoid timeout. Default is \`500\` ms.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`user\`',
        value: 'Details via a User object about the human user of the device; the advertising audience.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`user.data\`',
        value: 'Contains the \`name\` , \`id\` , and \`segment\` objects.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`user.data.name\`',
        value: 'If applicable, contains data specific to the ad unit, entered by the publisher in the MAX Dashboard. ',
        alwayspassed: 'no',
    },
    {
        attribute: '\`user.data.segment\`',
        value: 'Contains the \`signal\` field which contains any custom data the SDK bidder collects and passes to MAX SDK via the adapter (e.g. identity token required by the network so that networks or bidders can respond to a bid request).',
        alwayspassed: 'no',
    },
    {
        attribute: '\`user.ext\`',
        value: 'Placeholder for exchange-specific extensions to OpenRTB.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`user.ext.consent\`',
        value: '\`0\` if the user did not grant consent; \`1\` if the user granted consent.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`user.ext.gdpr\`',
        value: '\`0\` if the user is not subjected to GDPR; \`1\` if the user is subjected to GDPR.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`user.id\`',
        value: 'AppLovin-specific device ID for each user within each app.',
        alwayspassed: 'no',
    },
]

export const appObject = [
    {
        attribute: '\`bundle\`',
        value: 'Application iTunes ID or package name. On Android, this is the package name, for example \`com.example.app\`. On iOS, this is the iTunes ID, for example \`628677149\` .',
        alwayspassed: 'no',
    },
    {
        attribute: '\`cat\`',
        value: 'IAB content categories for the Application. See OpenRTB Spec 2.5 {List/SPACE/5.1}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A130%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C643%2C0%5D)  for details.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`content\`',
        value: 'Object that describes the content where the impression will appear for certain requests, including CTV inventory. Aligns to OpenRTB Section {3.2.16}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A95%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C317%2C0%5D)',
        alwayspassed: 'no',
    },
    {
        attribute: '\`content.ext\`',
        value: 'Placeholder for exchange-specific extensions to OpenRTB, including CTV inventory.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`content.url\`',
        value: 'URL of the content, for buy-side contextualization or review.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ext\`',
        value: 'Placeholder for exchange-specific extensions to OpenRTB.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ext.orientation_lock\`',
        value: 'Indicates device orientation: \`portrait\` or \`landscape\` .',
        alwayspassed: 'no',
    },
    {
        attribute: '\`id\`',
        value: 'Application ID on the AppLovin RTB',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`name\`',
        value: 'Application name on the AppLovin RTB',
        alwayspassed: 'no',
    },
    {
        attribute: '\`publisher\`',
        value: 'Details about the Publisher of the app.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`publisher.ext\`',
        value: 'Extension object containing additional publisher information. This contains the \`installed_sdk\` object which has fields \`id\` , and subobject \`SDK_version\` with SDK bidder name and version details. For DSP bidders, \`id\` will always be \`"APPLOVIN_EXCHANGE"\` .',
        alwayspassed: 'no',
    },
    {
        attribute: '\`publisher.id\`',
        value: 'The publisher’s AppLovin ID. Publishers should add this value to their \`app-ads.txt\` file.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`publisher.name\`',
        value: 'The publisher’s name.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`storeurl\`',
        value: 'The URL for the app in the App Store or Google Play Store. Used for \`app-ads.txt\` compliance.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`ver\`',
        value: 'Application version, passed when available.',
        alwayspassed: 'no',
    },
]

export const deviceObject = [
    {
        attribute: '\`carrier\` (optional)',
        value: 'Carrier of device on a cellular network, or ISB of device on WiFi. ',
        alwayspassed: 'no',
    },
    {
        attribute: '\`connectiontype\`',
        value: 'Type of connection as per {Table/SPACE/5.22}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A167%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C200%2C0%5D)  of the OpenRTB 2.5 spec {NEWLINE} {NEWLINE}' +
            '• \`0\` if unknown = always pass 0 if the SDK signal is not present. {NEWLINE}' +
            '• \`1\` (Ethernet) = if device is directly connected via Ethernet (Android only) {NEWLINE}' +
            '• \`2\` (Wifi) = if device is connected via WiFi (Android / iOS) {NEWLINE}' +
            '• \`3\` (Cellular) = if device is connected through EDGE, 3G, LTE, etc. (Android / iOS)',
        alwayspassed: 'no',
    },
    {
        attribute: '\`devicetype\`',
        value: 'The general type of device. Set to \`1\` for mobile and tablets. See OpenRTB Spec 2.5 {Table/SPACE/5.21}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A167%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C486%2C0%5D)  for details.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`dnt\`',
        value: 'Specifies whether the “Do Not Track” feature is enabled in the device. If \`0\` , then DNT is set to false. If \`1\` , then DNT is set to true. This parameter is omitted if DNT is not passed by the SDK or on iOS 5 or lower.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ext\`',
        value: 'Placeholder for exchange-specific extensions to OpenRTB.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ext.atts\`',
        value: '(iOS Only) An integer passed to represent the app’s app tracking authorization status, where {NEWLINE} '
             + '• 0 = not determined {NEWLINE} '
             + '• 1 = restricted {NEWLINE} '
             + '• 2 = denied {NEWLINE} '
             + '• 3 = authorized',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ext.ifv\`',
        value: 'IDFV of device in that publisher. Only passed when IDFA is unavailable or all zeros.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`geo\`',
        value: 'Location of the device assumed to be the user’s current location defined by a Geo object.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`h\`',
        value: 'Height of the screen in physical pixels. This may be dependent on the device orientation. Note this can differ from \`banner.h\` .',
        alwayspassed: 'no',
    },
    {
        attribute: '\`hwv\`',
        value: 'Hardware version of the device',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ifa\` (optional)',
        value: 'Apple IFA or Google Advertising ID. Google Advertising Id (Android) is lowercase by default; IFA (iOS) is uppercase by default. If raw is not available then this is not passed. Not passed in requests from countries subject to GDPR if the user does not give consent.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ip\`',
        value: 'IPv4 address of the device. Not passed in requests from countries subject to GDPR if the user does not give consent.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`ipv6\` (optional)',
        value: 'IPv6 address of the device. When \`ipv6\` is present, \`ip\` is \`255.255.255.255\` by default. Not passed in requests from countries subject to GDPR if the user does not give consent.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`js\`',
        value: '\`1\` if the device supports Javascript; otherwise \`0\` . (Always \``1\` .)',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`language\`',
        value: 'Browser language, using {ISO-639-1-alpha-2}(https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) .',
        alwayspassed: 'no',
    },
    {
        attribute: '\`lmt\`',
        value: '“Limit Ad Tracking” signal commercially endorsed (for example by iOS, Android), where \`0\` = tracking is unrestricted, \`1\` = tracking must be limited per commercial guidelines',
        alwayspassed: 'no',
    },
    {
        attribute: '\`make\`',
        value: 'Device make (for example, \`"Apple"\`)',
        alwayspassed: 'no',
    },
    {
        attribute: '\`mccmnc\`',
        value: 'Mobile Country Code and Mobile Network Code, concatenated with a dash (e.g. \`310-005\` ). See {the/SPACE/list/SPACE/of/SPACE/Mobile/SPACE/Country/SPACE/Codes}(https://en.wikipedia.org/wiki/Mobile_country_code)  for more details.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`model\`',
        value: 'Model of the device (for example, \`"iPhone"\`). iOS will show the full device model name, for example \`"iPhone 10,1"\`, if known, or just for example \`"iPhone\`" if not. Android will have detailed model information such as \`"SAMSUNG-SM-G900A"\`.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`os\`',
        value: 'Operating system of the device; either \`"iOS"\` or \`"Android"\`.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`osv\`',
        value: 'Operating system version of the device, for example \`"3.1.2"\`.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`pxratio\`',
        value: 'The ratio of physical pixels to device-independent pixels. A float value from 0.74 through 4.0.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`ua\`',
        value: 'Unprocessed \`User-Agent\` string from HTTP headers',
        alwayspassed: 'no',
    },
    {
        attribute: '\`w\`',
        value: 'Width of the screen in physical pixels. This may be dependent on the device orientation. Note this can differ from \`banner.w\` .',
        alwayspassed: 'no',
    },
]

export const geoObject = [
    {
        attribute: '\`city\`',
        value: 'City of the device. Based on the IP & Maxmind database.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`country\`',
        value: 'Country of the device. Based on the IP & Maxmind database. Passed as country code using {ISO-3166-1-alpha-3}(https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3) .',
        alwayspassed: 'no',
    },
    {
        attribute: '\`dma\`',
        value: 'Nielsen DMA code based on IP.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ext\`',
        value: 'Placeholder for exchange-specific extensions to OpenRTB.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ext.isp\`',
        value: 'Internet Service Provider name.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ext.org\`',
        value: 'Internet Service Provider name.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ipservice\`',
        value: 'Service or provider used to determine geolocation from IP address if applicable (that is, \`type\` = \`2\` ). Refer to {List/SPACE/5.23}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A171%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C622%2C0%5D)  in the OpenRTB Spec 2.5 for more details.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`lat\`',
        value: 'Latitude from −90.000 to +90.000, where negative is south. Truncated to three decimal places. Blank when not available.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`locale\`',
        value: 'Language and country of the device. Example \`us_en\` signifies English as language and the United States as the country.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`lon\`',
        value: 'Longitude from −180.000 to +180.000, where negative is west. Truncated to three decimal places. Blank when not available.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`metro\`',
        value: 'Zip code of the device. Based on the IP & Maxmind database.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`region\`',
        value: 'Region code using ISO-3166-2; 2-letter state code if USA. Always derived from IP, never a reverse geocode from \`lat\` / \`lon\` .',
        alwayspassed: 'no',
    },
    {
        attribute: '\`type\`',
        value: 'Source of location data; recommended when passing \`lat\` / \`lon\` . Refer to {List/SPACE/5.20}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A167%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C637%2C0%5D)  in the OpenRTB Spec 2.5 for more details.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`zip\` (optional)',
        value: 'Zip code of the user. Always derived from , never a reverse geocode from \`lat\` / \`lon\` .',
        alwayspassed: 'no',
    },
]

export const impressionObject = [
    {
        attribute: '\`banner\`',
        value: 'A Banner object (see “Banner Object”)–required if this impression is offered as a banner ad opportunity.',
        alwayspassed: 'only for banner impressions',
    },
    {
        attribute: '\`bidfloor\`',
        value: 'CPM minimum bid amount. Default currency is USD.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`displaymanager\`',
        value: 'Will pass “applovin” when the SDK is present.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`displaymanagerserver\`',
        value: 'AppLovin SDK version passed from the SDK, otherwise not passed.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`exp\`',
        value: 'Advisory as to the number of seconds that may elapse between the auction and the actual impression. Fixed value of \`14400\` = 4 hours × 3600 seconds/hour.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`ext\`',
        value: 'Placeholder for exchange-specific extensions to OpenRTB.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ext.skadn\`',
        value: 'Support for Apple’s SKAdNetwork. See the OpenRTB {SKAdNetwork/SPACE/extension}(https://github.com/InteractiveAdvertisingBureau/openrtb/blob/master/extensions/community_extensions/skadnetwork.md#bid-request)  for additional details.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ext.skadn.skadnetids\`',
        value: 'A subset of \`SKAdNetworkItem\` entries in the publisher app’s \`Info.plist\` that are relevant to the DSP.',
        alwayspassed: 'yes (if \`ext.skadn\` is passed)',
    },
    {
        attribute: '\`ext.skadn.skadnetlist.max\`',
        value: 'IABTL list containing the max entry ID of SKAdNetwork ID.',
        alwayspassed: '',
    },
    {
        attribute: '\`ext.skadn.skadnetlist.excl\`',
        value: 'Comma-separated list of integer IABTL registration IDs to be excluded from IABTL shared list.',
        alwayspassed: '',
    },
    {
        attribute: '\`ext.skadn.sourceapp\`',
        value: 'ID of publisher app in Apple’s App Store. Matches \`app.bundle\` .',
        alwayspassed: 'yes (if \`ext.skadn\` is passed)',
    },
    {
        attribute: '\`ext.skadn.version\`',
        value: 'Version of SKAdNetwork supported. Always \`"2.0"\` or higher. Dependent on both the OS version and the SDK version. Note: With the release of SKAdNetwork 2.1, this field is deprecated in favor of \`BidRequest.imp.ext.skadn.versions\` to support an array of version numbers.',
        alwayspassed: 'yes (if \`ext.skadn\` is passed)',
    },
    {
        attribute: '\`ext.skadn.versions\`',
        value: 'Array of strings containing the supported skadnetwork versions. Always \`"2.0"\` or higher. Dependent on both the OS version and the SDK version.',
        alwayspassed: 'yes (if \`ext.skadn\` is passed)',
    },
    {
        attribute: '\`ext.skadnetids\`',
        value: 'IDs associated with Advanced Bidders only.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`id\`',
        value: 'A unique identifier for the impression within the bid request. Typically the value starts with \`1\` , then increments of up to n for n impressions.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`instl\`',
        value: 'Indicates if impression is offered as an interstitial opportunity. Set to \`1\` for full screen (interstitial), or \`0\` if interstitial is not available.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`metric\`',
        value: 'An array of Metric objects (see {“Metric/SPACE/Object”}(#metric-object) ).',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`native\`',
        value: 'A Native object (see {“Native/SPACE/Object”}(#native-object) )—required if this impression is offered as a native ad opportunity.',
        alwayspassed: 'only for native impressions',
    },
    {
        attribute: '\`rwdd\`',
        value: 'Indicates whether the user receives a reward for viewing the ad, where \`0\` = no, \`1\` = yes.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`secure\`',
        value: 'Flag that indicates if the impression requires secure HTTPS URL creative assets and markup, where \`0\` = Non-secure, \`1\` = secure. If omitted, the secure state is unknown, but non-secure HTTP support can be assumed. For iOS auctions, this will always be \`1\` = secure.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`tagid\`',
        value: 'Identifier for specific ad placement or ad tag that was used to initiate the auction. For SDK bidders, the network placement ID for this impression.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`video\`',
        value: 'A Video object (see {“Video/SPACE/Object”}(#video-object) )—required if this impression is offered as a video ad opportunity.',
        alwayspassed: 'only for video impressions',
    },
]

export const metricObject = [
    {
        attribute: 'type',
        type: 'string',
        value: 'Type of metric being presented using exchange-curated string names. {NEWLINE} '
              + 'Session duriation ( \`session_duration\` ) is the total time a user has spent in a specific app, in seconds. {NEWLINE}{NEWLINE} '
              + 'Session depth ( \`session_depth\` ) is the total number of ads a user has seen in a given app session. A session ends after a user has closed the app. Both session depth and session depth per ad format will be present in the bid request. {NEWLINE}{NEWLINE} '
              + 'The following represent the total number of ads per format a user has seen in the app session: {NEWLINE} '
              + ' • \`session_depth_banner\` {NEWLINE} '
              + ' • \`session_depth_full\` {NEWLINE} '
              + ' • \`session_depth_medium_rectangle\` {NEWLINE} '
              + ' • \`session_depth_native\` {NEWLINE} '
              + ' • \`session_depth_rewarded\`',
    },
    {
        attribute: 'value',
        type: 'float',
        value: 'Number representing the value of the metric. Not present for Viewability type. {NEWLINE}{NEWLINE} Session Depth: Set to \`0.0\` if the user has not yet seen an ad within their current app session, or if the user has been inactive for 30 minutes.',
    },
    {
        attribute: 'vendor',
        type: 'string',
        value: 'Source of the value using exchange-curated string names. If the exchange itself is the source (as opposed to a third party), `EXCHANGE` will always be used unless specified otherwise. {NEWLINE}{NEWLINE} Viewability: Set to \`ias\` for Integral Ad Science (IAS); set to \`moat\` for Moat. Dependent on the partners that are supported by the publisher. If only one is supported, only one will be passed. If both are supported, both will be passed. Does not apply to Open Measurement Viewability.',
    },
]

export const videoObject = [
    {
        attribute: '\`api\`',
        value: 'List of supported API frameworks for this impression. See OpenRTB Spec 2.5 {Table/SPACE/5.6}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details. If an API is not explicitly listed, it is assumed not to be supported.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`battr\`',
        value: 'Blocked creative attributes. See OpenRTB Spec 2.5 {Table/SPACE/5.3}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`companiontype\`',
        value: 'Supported VAST ad companion types. See OpenRTB Spec 2.5 {Table/SPACE/5.14}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details. Some inventory supports all companion types and others static only.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`ext.videotype\`',
        value: '\`"rewarded"\` if it’s a rewarded request',
        alwayspassed: 'no',
    },
    {
        attribute: '\`h\`',
        value: 'Height of the player in pixels.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`linearity\`',
        value: 'Indicates if the impression must be linear. This is set to \`1\` for all requests.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`maxbitrate\`',
        value: 'Maximum bit rate in Kbps.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`maxduration\`',
        value: 'Maximum video ad duration in seconds.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`mimes\`',
        value: 'Content MIME types supported. \`video/mp4\` is supported.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`minbitrate\`',
        value: 'Minimum bit rate in Kbps.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`minduration\`',
        value: 'Minimum video ad duration in seconds.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`placement\`',
        value: 'Placement type for the impression. See OpenRTB Spec 2.5 {Table/SPACE/5.9}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`playbackmethod\`',
        value: 'Allowed playback methods. If none specified, assume all are allowed. See OpenRTB Spec 2.5 {Table/SPACE/5.10}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`plcmt\`',
        value: 'Video placement subtype for the impression. See {List:/SPACE/Plcmt/SPACE/Subtypes—Video}(https://github.com/InteractiveAdvertisingBureau/AdCOM/blob/develop/AdCOM%20v1.0%20FINAL.md#list_plcmtsubtypesvideo)  in AdCOM Specification 1.0.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`pos\`',
        value: 'Ad position on screen. See OpenRTB Spec 2.5 {Table/SPACE/5.4}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`protocols\`',
        value: 'Array of supported video bid response protocols. VAST 2, VAST 3, and VAST 4 are supported. Protocols will reflect what the specific inventory source supports as some inventory only supports 2.0, others both 2.0/3.0. See OpenRTB Spec 2.5 {Table/SPACE/5.8}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`skipafter\`',
        value: 'Number of seconds a video must play before skipping is enabled; only applicable if the ad is skippable',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`skipmin\`',
        value: 'Videos of total duration greater than this number of seconds can be skippable; only applicable if the ad is skippable.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`startdelay\`',
        value: 'Indicates the start delay in seconds for pre-roll, mid-roll, or post-roll ad placements. See OpenRTB Spec 2.5 {Table/SPACE/5.12}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`w\`',
        value: 'Width of the player in pixels.',
        alwayspassed: 'yes',
    },
]

export const bannerObject = [
    {
        attribute: '\`api\`',
        value: 'List of supported API frameworks for this impression. See OpenRTB Spec 2.5 {Table/SPACE/5.6}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details. If an API is not explicitly listed, it is assumed not to be supported.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`battr\`',
        value: 'Blocked creative attributes for banner. See OpenRTB Spec 2.5 {Table/SPACE/5.3}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`btype\`',
        value: 'An array of integers indicating blocked types of banners. See OpenRTP Spec 2.5 {Table/SPACE/5.2}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`ext.bannertype\`',
        value: '\`"rewarded"\` if it’s a rewarded request',
        alwayspassed: 'no',
    },
    {
        attribute: '\`format\`',
        value: 'Array of format objects representing the banner sizes permitted. Height ( \`h\` ) and width ( \`w\` ) available to pass. If none are specified, then AppLovin recommends that you use the \`Bidrequest.imp.banner.h\` and \`Bidrequest.imp.w\` attributes.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`h\`',
        value: 'Height of the impression in pixels.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`id\`',
        value: 'A unique identifier for this object. Values usually start at \`1\`and increase with each object; should be unique within an impression.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`pos\`',
        value: 'Ad position on screen. See OpenRTB Spec 2.5 {Table/SPACE/5.4}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details. AppLovin RTB will always pass \`1\` = Above the Fold.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`w\`',
        value: 'Width of the impression in pixels.',
        alwayspassed: 'yes',
    },
]

export const nativeObject = [
    {
        attribute: '\`api\`',
        value: 'List of supported API frameworks for this impression. See OpenRTB Spec 2.5 {Table/SPACE/5.6}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details. If an API is not explicitly listed, it is assumed not to be supported.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`battr\`',
        value: 'Blocked creative attributes for the native ad. See OpenRTB Spec 2.5 {Table/SPACE/5.3}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A143%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C550%2C0%5D)  for details.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`eventtrackers\`',
        value: 'Array of tracking objects to run with the ad, in response to the declared supported methods in the request. Replaces \`imptrackers\` and \`jstracker\`, to be deprecated. See {OpenRTB/SPACE/Spec/SPACE/1.2}(https://www.iab.com/wp-content/uploads/2018/03/OpenRTB-Native-Ads-Specification-Final-1.2.pdf)  section 4.7: Event Trackers Request Object for details.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`request\`',
        value: 'Request payload complying with the Native Ad Specification. Note that this is a string.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`request.assets\`',
        value: 'An array of AssetObjects. Any bid must comply with the array of elements expressed by the Exchange.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`request.assets[n].data\`',
        value: 'Data object for ratings, prices, etc. See Data Object definition below.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`request.assets[n].id\`',
        value: 'Unique asset ID, assigned by exchange.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`request.assets[n].img.hmin\`',
        value: 'The minimum requested height of the image, in pixels. Use this option for any rescaling of images by the client. Either \`h\` or \`hmin\` should be transmitted. If only \`h\` is included, it should be considered an exact requirement. Set for icon image with a value of 80—require 1:1 aspect ratio. Set for main image with a value of 417—require 1.91:1 aspect ratio (1200×627, 1200×628, and 800×418 recommended).',
        alwayspassed: 'no',
    },
    {
        attribute: '\`request.assets[n].img.type\`',
        value: 'Type ID of the image element supported by the publisher. The publisher can display this information in an appropriate format. See OpenRTB Native 1.2 {Table/SPACE/7.4/SPACE/and/SPACE/7.5}(https://www.iab.com/wp-content/uploads/2018/03/OpenRTB-Native-Ads-Specification-Final-1.2.pdf)  for details.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`request.assets[n].img.wmin\`',
        value: 'The minimum requested width of the image, in pixels. Use this option for any rescaling of images by the client. Either \`w\` or \`wmin\` should be transmitted. If only \`w\` is included, it should be considered an exact requirement. Set for icon image with a value of 80—require 1:1 aspect ratio. Set for main image with a value of 800—require 1.91:1 aspect ratio (1200×627, 1200×628, and 800×418 recommended).',
        alwayspassed: 'no',
    },
    {
        attribute: '\`request.assets[n].required\`',
        value: 'Set to \`1\` if asset is required (exchange will not accept a bid without it).',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`request.context\`',
        value: 'The context in which the ad appears; set to \`1501\` .',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`request.privacy\`',
        value: 'Set to \`1\` when the native ad supports buyer-specific privacy notice. Field is absent when the native ad doesn’t support custom privacy links or if support is unknown.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`request.seq\`',
        value: '(see the layout types). \`0\` for the first ad, \`1\` for the second ad, and so on. This is not the sequence number of the content in the stream.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`ver\`',
        value: 'Version of the Native Ad Specification to which the request complies; set to \`1.2\` .',
        alwayspassed: 'yes',
    },
]

export const regsextObject = [
    {
        attribute: '\`ccpa\`',
        value: 'Flag indicating if this request is subject to the CCPA regulations, where \`0\` = no, \`1\` = yes.',
        alwayspassed: 'yes',
    },
    {
        attribute: '\`consent\`',
        value: 'Flag indicating if a user has granted consent, where \`0\` = no, \`1\` = yes.',
        alwayspassed: 'no',
    },
    {
        attribute: '\`gdpr\`',
        value: 'Flag indicating if this request is subject to the GDPR regulations, where \`0\` = no, \`1\` = yes.',
        alwayspassed: 'yes',
    },
]

export const bidResponseObject = [
    {
        attribute: '\`bidid\`',
        value: 'Bidder generated response ID to assist with logging/tracking.',
        type: 'string',
        required: 'no',
    },
    {
        attribute: '\`cur\`',
        value: 'Currently only accepts, and defaults to, \`"USD"\` .',
        type: 'string',
        required: 'no',
    },
    {
        attribute: '\`id\`',
        value: 'ID of the bid request to which this is a response (that is, it must match \`bidrequest.id\` ).',
        type: 'string',
        required: 'yes',
    },
    {
        attribute: '\`nbr\`',
        value: 'Reason for not bidding. Refer to {List/SPACE/5.24}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A171%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C454%2C0%5D)  of the OpenRTB 2.5 spec.',
        type: 'integer',
        required: 'recommended',
    },
    {
        attribute: '\`seatbid\`',
        value: 'Array of {seatbid/SPACE/objects}(#seatbid-object) ; one or more are required if a bid is to be made.',
        type: 'object array',
        required: 'yes',
    },
]

export const seatbidObject = [
    {
        attribute: '\`bid\`',
        value: 'Array of {bid/SPACE/objects}(#bid-object) ; one or more are required if a bid is to be made.',
        type: 'object array',
        required: 'yes',
    },
    {
        attribute: '\`seat\`',
        value: 'ID of the bidder seat on whose behalf this bid is made. A bid response may contain bids from multiple “seats” or contain multiple bids from the same seat. MUST be an alphanumeric string, maximum 40 characters, ideally minimum 8 characters. Not currently supported.',
        type: 'string',
        required: 'no',
    },
]

export const bidObject = [
    {
        attribute: '\`adid\`',
        value: 'ID of a preloaded ad to be served if the bid wins.',
        type: 'string',
        required: 'no',
    },
    {
        attribute: '\`adm\`',
        value: 'The main means of conveying ad markup in case the bid wins; supersedes the win notice if markup is included in both. Substitution macros may be included. Refer to {supported/SPACE/macros}(/documentation/mediation/auctions/dsps/ortb-spec/bid-response#win/loss/billing-notifications) . For native ad format \`adm_native\` is supported.',
        type: 'string',
        required: 'yes',
    },
    {
        attribute: '\`adomain\`',
        value: 'This field contains an array of advertiser domain names. AppLovin RTB uses only the first domain in the array.{NEWLINE}{NEWLINE}Advertiser domains must match the top-level domain for the advertiser landing page, and not the full landing page URL. For app store landing pages, \`adomain\` should match the app owner’s top-level domain and not the full app store URL.{NEWLINE}{NEWLINE}The value of \`adomain\` must not include \`http://\` or \`https://\` or any \`/\` (slash) characters.{NEWLINE}{NEWLINE} Example: \`yourapp.com\` (but not \`yourapp.com/something\` or \`https://yourapp.com\` ) .',
        type: 'string array',
        required: 'yes',
    },
    {
        attribute: '\`api\`',
        value: 'See OpenRTB Spec 2.5 {Table/SPACE/5.6}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A147%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C319%2C0%5D)  for details.',
        type: 'integer',
        required: 'no',
    },
    {
        attribute: '\`apis\`',
        value: 'List of supported API frameworks for this impression. One of the following: {NEWLINE} '
        + '• \`1\` = VPAID 1.0 (not supported on ALX) {NEWLINE} '
        + '• \`2\` = VPAID 2.0 (not supported on ALX) {NEWLINE} '
        + '• \`3\` = MRAID-1 {NEWLINE} '
        + '• \`4\` = ORMMA {NEWLINE} '
        + '• \`5\` = MRAID-2 {NEWLINE} '
        + '• \`6\` = MRAID-3 {NEWLINE} '
        + '• \`7\` = OMID-1 {NEWLINE} ',
        type: 'integer array',
        required: '',
    },
    {
        attribute: '\`attr\`',
        value: 'Required when applicable, creative attributes, an array of values taken from this list: {NEWLINE}'
             + '•  \`1\` = Audio Ad (Auto-Play) {NEWLINE} '
             + '•  \`2\` = Audio Ad (User Initiated) {NEWLINE} '
             + '•  \`3\` = Expandable (Automatic) {NEWLINE} '
             + '•  \`4\` = Expandable (User Initiated–Click) {NEWLINE} '
             + '•  \`5\` = Expandable (User Initiated–Rollover) {NEWLINE} '
             + '•  \`6\` = In-Banner Video Ad (Auto-Play) {NEWLINE} '
             + '•  \`7\` = In-Banner Video Ad (User Initiated) {NEWLINE} '
             + '•  \`8\` = Pop (e.g. Over, Under, or Upon Exit) {NEWLINE} '
             + '•  \`9\` = Provocative or Suggestive Imagery {NEWLINE} '
             + '• \`10\` = Shaky, Flashing, Flickering, Extreme Animation, Smileys {NEWLINE} '
             + '• \`11\` = Surveys {NEWLINE} '
             + '• \`12\` = Text Only {NEWLINE} '
             + '• \`13\` = User Interactive (e.g. Embedded Games) {NEWLINE} '
             + '• \`14\` = Windows Dialog or Alert Style {NEWLINE} '
             + '• \`15\` = Has Audio On/Off Button {NEWLINE} '
             + '• \`16\` = Ad Provides Skip Button (e.g. VPAID-rendered skip button on pre-roll video) {NEWLINE} '
             + '• \`17\` = Adobe Flash {NEWLINE} '
             + 'When present, this must be accurate and reflect the actual creative, otherwise it is a policy violation. This field is not required for serving VAST video but is required for serving HTML or MRAID in-banner video.',
        type: 'integer array',
        required: 'recommended',
    },
    {
        attribute: '\`bundle\`',
        value: 'This field contains the advertiser’s application iTunes ID or Android package name. If this is not an application install ad, leave this field blank. Do not pass the publisher’s application bundle or AppLovin RTB will reject the response. {NEWLINE}{NEWLINE} Examples: \`com.example.app\` on Android, \`628677149\` on iOS.',
        type: 'string',
        required: 'required if \`ext.skadn\` is present; recommended in all cases',
    },
    {
        attribute: '\`burl\`',
        value: 'Billing notice URL called by the exchange when a winning bid becomes billable. DSPs must use \`burl\` for impression and spend tracking. AppLovin will only investigate discrepancies when \`burl\` is used.',
        type: 'string',
        required: 'yes',
    },
    {
        attribute: '\`cat\`',
        value: 'IAB content categories of the creative. Refer to {section/SPACE/5.1}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A130%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C643%2C0%5D)  of the OpenRTB 2.5 spec.',
        type: 'string array',
        required: 'yes',
    },
    {
        attribute: '\`cid\`',
        value: 'Campaign ID to assist with ad quality checking; the collection of creatives for which \`iurl\` should be representative.',
        type: 'string',
        required: 'recommended',
    },
    {
        attribute: '\`crid\`',
        value: 'This field uniquely identifies a creative for a campaign. Do not assign a new creative ID to the same creative just to indicate that the creative is appearing in a new impression.',
        type: 'string',
        required: 'yes',
    },
    {
        attribute: '\`dealid\`',
        value: 'Reference to the \`deal.id\` from the bid request if this bid pertains to an inventory package. Do not pass unless bidding against an inventory package.',
        type: 'string',
        required: 'yes, for inventory packages',
    },
    {
        attribute: '\`ext\`',
        value: 'Placeholder for bidder-specific extensions to OpenRTB.',
        type: 'object',
        required: 'no',
    },
    {
        attribute: '\`ext.crtype\`',
        value: 'This field describes the type of ad you are serving. Valid values are: {NEWLINE} '
             + '• HTML {NEWLINE} '
             + '• MRAID 1.0 {NEWLINE} '
             + '• MRAID 2.0 {NEWLINE} '
             + '• MRAID 3.0 {NEWLINE} '
             + '• native {NEWLINE} '
             + '• VAST 2.0 {NEWLINE} '
             + '• VAST 3.0 {NEWLINE} '
             + '• VAST 4.0 {NEWLINE} '
             + '• VAST 4.1 {NEWLINE} '
             + '• VAST 4.2 {NEWLINE} {NEWLINE} '
             + 'AppLovin can hardcode the \`crtype\` for you if you buy only one \`crtype\` . Contact your AppLovin account manager if you would like to do this. Passing \`crtype\` in \`bid.crtype\` is also supported.',
        type: 'string',
        required: 'recommended',
    },
    {
        attribute: '\`ext.clicktrackers\`',
        value: 'Click tracking URLs (first- and third-party) to be consistently tracked when AppLovin records the click event. This does not apply to native.',
        type: 'string array',
        required: 'yes, if running HTML ads + SKAD (SKAdNetwork)',
    },
    {
        attribute: '\`ext.duration\`',
        value: 'Video duration, in seconds.',
        type: 'integer',
        required: 'yes, for CTV inventory',
    },
    {
        attribute: '\`ext.imptrackers\`',
        value: 'Impression tracking URL to be used by third-party tracking needs. This does not apply for native. See native object \`eventtrackers\` .',
        type: 'string array',
        required: 'no',
    },
    {
        attribute: '\`ext.skadn\`',
        value: 'Parameters required to support Apple’s SKAdNetwork attribution API, via \`loadProduct()\` .',
        type: 'object',
        required: 'no',
    },
    {
        attribute: '\`ext.skadn.campaign\`',
        value: 'Campaign ID (2.0–3.0) or Source ID (4.0+). This should be an integer between 1 and 100 for SKAdNetwork versions 2.0–3.0, or between 0 and 9999 for versions 4.0+, expressed as a string.',
        type: 'string',
        required: 'if `ext.skadn` is present',
    },
    {
        attribute: '\`ext.skadn.fidelities\`',
        value: 'Supports multiple fidelity types introduced in SKAdNetwork v2.2.',
        type: 'object array',
        required: 'if `ext.skadn` is present',
    },
    {
        attribute: '\`ext.skadn.fidelities[n].fidelity\`',
        value: 'The fidelity-type of the attribution to track.',
        type: 'integer',
        required: 'if `ext.skadn` is present',
    },
    {
        attribute: '\`ext.skadn.fidelities[n].nonce\`',
        value: 'An ID unique to each ad response. Refer to Apple’s documentation for {the/SPACE/proper/SPACE/UUID/SPACE/format/SPACE/requirements}(https://developer.apple.com/documentation/storekit/skstoreproductparameteradnetworknonce) .',
        type: 'string',
        required: 'if `ext.skadn` is present',
    },
    {
        attribute: '\`ext.skadn.fidelities[n].signature\`',
        value: 'SKAdNetwork signature as specified by Apple.',
        type: 'string',
        required: 'if `ext.skadn` is present',
    },
    {
        attribute: '\`ext.skadn.fidelities[n].timestamp\`',
        value: 'Unix time in millis string used at the time of \`signature\` .',
        type: 'string',
        required: 'if `ext.skadn` is present',
    },
    {
        attribute: '\`ext.skadn.itunesitem\`',
        value: 'ID of advertiser’s app in Apple’s app store. Should match \`BidResponse.seatbid.bid.bundle\` .',
        type: 'string',
        required: 'if `ext.skadn` is present',
    },
    {
        attribute: '\`ext.skadn.network\`',
        value: 'Ad network identifier used in signature. Should match one of the items in the \`skadnetids\` array in the request.',
        type: 'string',
        required: 'if `ext.skadn` is present',
    },
    {
        attribute: '\`ext.skadn.nonce\`',
        value: 'An id unique to each ad response. Refer to Apple’s documentation for the {proper/SPACE/UUID/SPACE/format/SPACE/requirements}(https://developer.apple.com/documentation/storekit/skstoreproductparameteradnetworknonce) . Note: With the release of SKAdNetwork v2.2, this field is deprecated in favor of the \`BidResponse.seatbid.bid.ext.skadn.fidelities.nonce\` to support multiple fidelity-types.',
        type: 'string',
        required: 'if `ext.skadn` is present',
    },
    {
        attribute: '\`ext.skadn.productpage\`',
        value: 'Custom Product Page ID (available as of SDK 11.1.1)',
        type: 'string',
        required: 'no',
    },
    {
        attribute: '\`ext.skadn.signature\`',
        value: 'SKAdNetwork signature as specified by Apple. Note: With the release of SKAdNetwork 2.2, this field is deprecated in favor of the \`BidResponse.seatbid.bid.ext.skadn.fidelities.signature\` to support multiple fidelity-types.',
        type: 'string',
        required: 'if `ext.skadn` is present',
    },
    {
        attribute: '\`ext.skadn.skoverlay\`',
        value: 'Parameters to control a potential SKOverlay (available as of SDK 10.0.0). The overlay can be triggered (with delay, or 0 for no delay) after video starts, companion ad renders, or user dismisses the overlay but the ad remains open. Note: AppLovin does not track clicks on SKOverlay, as Apple does not provide a click callback.',
        type: 'object',
        required: 'no',
    },
    {
        attribute: '\`ext.skadn.skoverlay.position\`',
        value: 'Position of the overlay. 0 = bottom, 1 = bottomRaised. Defaults to 0.',
        type: 'integer',
        required: 'no',
    },
    {
        attribute: '\`ext.skadn.skoverlay.dismissable\`',
        value: 'Whether or not the user can dismiss the overlay (1 means it can be dismissed, 0 means it is static on the screen). Defaults to 1.',
        type: 'integer',
        required: 'no',
    },
    {
        attribute: '\`ext.skadn.skoverlay.video_delay\`',
        value: 'Number of seconds after the video starts to show the overlay. Keep this unset (null) to not trigger based on video start.',
        type: 'integer',
        required: 'no',
    },
    {
        attribute: '\`ext.skadn.skoverlay.companion_delay\`',
        value: 'Number of seconds after the companion ad renders to show the overlay. Keep this unset (null) to not trigger based on companion ad render.',
        type: 'integer',
        required: 'if `ext.skadn.skoverlay` is present',
    },
    {
        attribute: '\`ext.skadn.skoverlay.sk_dismiss_delay\`',
        value: 'Number of seconds after the presented StoreKit screen is dismissed before showing the overlay. Keep this unset (null) to not trigger based on StoreKit dismiss (available as of SDK 11.3.4).',
        type: 'integer',
        required: 'if `ext.skadn.skoverlay` is present',
    },
    {
        attribute: '\`ext.skadn.sourceapp\`',
        value: 'ID of publisher’s app in Apple’s app store. Should match \`BidRequest.imp.ext.skad.sourceapp\` .',
        type: 'string',
        required: 'if `ext.skadn` is present',
    },
    {
        attribute: '\`ext.skadn.timestamp\`',
        value: 'Unix time in millis string used at the time of \`signature\` . Note: With the release of SKAdNetwork 2.2, this field is deprecated in favor of the \`BidResponse.seatbid.bid.ext.skadn.fidelities.timestamp\` to support multiple fidelity-types.',
        type: 'string',
        required: 'if `ext.skadn` is present',
    },
    {
        attribute: '\`ext.skadn.version\`',
        value: 'Version of SKAdNetwork desired. Must be 2.0 or above.',
        type: 'string',
        required: 'if `ext.skadn` is present',
    },
    {
        attribute: '\`ext.vendor\`',
        value: 'Name of viewability vendor(s) that will be measuring viewability for the ad that is shown. You should only declare viewability vendors in the bid response when you are collecting viewability measurement for an impression. Set to \`"ias\`" for Integral Ad Science (IAS). Set to \`"moat\`" for Moat Buyers are required to respond with the vendor in the bid response when they are returning a display campaign for viewability. Does not apply to Open Measurement Viewability.',
        type: 'string array',
        required: 'for campaigns that measure viewability',
    },
    {
        attribute: '\`h\`',
        value: 'Height of the creative in density-independent pixels.',
        type: 'integer',
        required: 'recommended',
    },
    {
        attribute: '\`id\`',
        value: 'Bidder generated bid ID to assist with logging/tracking.',
        type: 'string',
        required: 'yes',
    },
    {
        attribute: '\`impid\`',
        value: 'ID of {the/SPACE/Impression/SPACE/object}(#impression-object)  in the related bid request.',
        type: 'string',
        required: 'yes',
    },
    {
        attribute: '\`lurl\`',
        value: 'Loss notice URL called by the exchange when a bid is known to have been lost. Substitution macros may be included. Refer to {supported/SPACE/macros}(#win/loss/billing-notifications) .',
        type: 'string',
        required: 'no',
    },
    {
        attribute: '\`nurl\`',
        value: 'Win notice URL called by the exchange if the bid wins the impression opportunity.',
        type: 'string',
        required: 'recommended',
    },
    {
        attribute: '\`price\`',
        value: 'Bid price expressed as CPM, although the actual transaction is for a unit impression only. Note that while the type indicates \`float\`, integer math is highly recommended when handling currencies (for example, \`BigDecimal\` in Java).',
        type: 'float',
        required: 'yes',
    },
    {
        attribute: '\`protocol\`',
        value: 'Video response protocol of the markup if applicable. See OpenRTB Spec 2.5 {Table/SPACE/5.8}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A150%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C538%2C0%5D)  for details.',
        type: 'integer',
        required: 'no',
    },
    {
        attribute: '\`w\`',
        value: 'Width of the creative in density-independent pixels.',
        type: 'integer',
        required: 'recommended',
    },
]

export const trackingFields = [
    {
        tracker: '\`bidresponse.bid.burl\`',
        method: 'Fired server-side. \`X-Device-IP\` and \`X-Device-User-Agent\` are sent as headers in the server-to-server callbacks: {NEWLINE}{NEWLINE} \`X-Device-IP\` : Actual user device IP {NEWLINE} \`X-Device-User-Agent\` : Actual user device UA',
        recommendeduse: 'Impression and spend tracking for the buyer (DSP)'
    },
    {
        tracker: '\`bidresponse.bid.ext.imptrackers\`',
        method: 'Fired server-side. \`X-Device-IP\` and \`X-Device-User-Agent\` are sent as headers in the server-to-server callbacks: {NEWLINE}{NEWLINE} \`X-Device-IP\` : Actual user device IP {NEWLINE} \`X-Device-User-Agent\` : Actual user device UA',
        recommendeduse: 'Impression tracking by partners'
    },
    {
        tracker: '\`bidresponse.bid.adm\`',
        method: '• HTML Fired client-side {NEWLINE} • VAST \`<ImpressionTracker>\` node Fired server-side. \`X-Device-IP\` and \`X-Device-User-Agent\` are sent as headers in the server-to-server callbacks: {NEWLINE}{NEWLINE} \`X-Device-IP\` : Actual user device IP {NEWLINE} \`X-Device-User-Agent\` : Actual user device UA',
        recommendeduse: '• HTML: Invalid Traffic (IVT) tracking {NEWLINE} '
                      + '• VAST: Impression tracking by partners'
    },
    {
        tracker: '\`bidresponse.bid.adm.native.eventtrackers\`',
        method: 'Fired client-side',
        recommendeduse: '• Invalid Traffic (IVT) tracking {NEWLINE} '
                      + '• Open Measurement SDK (OMSDK) {NEWLINE} '
                      + '• Impression tracking by partners {NEWLINE} {NEWLINE} '
                      + 'Supports \`img\` and \`js\` tags as defined in “methods” in 7.7 Event Tracking Methods Table of Open RTB 2.1 Native Ads Spec. {NEWLINE} {NEWLINE} '
                      + 'DSPs are encouraged to use \`native.eventtrackers\` rather than \`native.imptrackers\` or \`native.jstracker\` as those fields are pending deprection by IAB (being deprecated in favor of \`eventtrackers\`). '
    },
    {
        tracker: '\`bidresponse.bid.adm.native.imptrackers\`',
        method: 'Fired client-side (being deprecated in favor of \`eventtrackers\` )',
        recommendeduse: 'Invalid Traffic (IVT) tracking'
    },
    {
        tracker: '\`bidresponse.bid.adm.native.jstracker\`',
        method: 'Fired client-side (being deprecated in favor of \`eventtrackers\` )',
        recommendeduse: 'Open Measurement SDK (OMSDK)'
    },
]

export const rtbMacros = [
    {
        macro: '\`AUCTION_BID_ID\`',
        description: 'ID of the bid, from the \`BidResponse.bidid\` attribute.'
    },
    {
        macro: '\`AUCTION_ID\`',
        description: 'ID of the bid request, from the \`BidRequest.id\` attribute.'
    },
    {
        macro: '\`AUCTION_LOSS\`',
        description: 'Loss reason code, as found in {Table/SPACE/5.25/SPACE/of/SPACE/the/SPACE/OpenRTB/SPACE/2.5/SPACE/spec}(https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf#%5B%7B%22num%22%3A171%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C69%2C152%2C0%5D) . Is only sent on \`lurl\` . {NEWLINE} {NEWLINE} Note that loss code “103 Lost to a Bid for a PMP Deal” will be used when the impression is won by a Direct Sold campaign at a higher priority.'
    },
    {
        macro: '\`AUCTION_MINIMUM_BID_TO_WIN\`',
        description: 'Second highest bid price. If there is no winner, floor price is sent. Is only sent on \`nurl\` . Value passed is \`0\` when there is only one bid: the winning bid.'
    },
    {
        macro: '\`AUCTION_PRICE\`',
        description: 'The auction clearing price. Uses the same currency and units as the bid. May be up to six decimals.'
    },
]
